import { render, staticRenderFns } from "./ModalIframe.vue?vue&type=template&id=48670e50&scoped=true&"
import script from "./ModalIframe.vue?vue&type=script&lang=ts&"
export * from "./ModalIframe.vue?vue&type=script&lang=ts&"
import style0 from "./ModalIframe.vue?vue&type=style&index=0&id=48670e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48670e50",
  null
  
)

export default component.exports